export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  "https://escolar.cecytejalisco.edu.mx/SistemaEscolarJalisco/funcion";

export const PAGOS_API_URL =
  process.env.REACT_APP_PAGOS_API_URL ||
  "https://api.multipagos.cecytejalisco.edu.mx";

export const PINPAD_URL =
  process.env.REACT_APP_PINPAD_URL || "http://localhost:5050/api/cobrar";
